import Vue from 'vue';
import vueHeadful from 'vue-simple-headful'

Vue.use(vueHeadful)
